export default {
  getCurrentPatientCare(state) {
    return state.patientCare
  }
}
